export const RX_UNDERSCORE = /_/g
export const RX_LOWER_UPPER = /([a-z])([A-Z])/g
export const RX_START_SPACE_WORD = /(\s|^)(\w)/g
export const RX_FIRST_START_SPACE_WORD = /(\s|^)(\w)/
export const RX_SPACE_SPLIT = /\s+/
export const RX_HASH = /^#/
export const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/

export const RX_STRIP_LOCALE_MODS = /-u-.+/
